import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Toast {
  title?: string;
  description: string;
  type?: string;
  duration?: number;
}

export interface ToastServiceAction extends Toast {
  show: boolean;
}

const DEFAULT_DURATION = 5000;

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private _toast$ = new BehaviorSubject<ToastServiceAction>({ description: '', show: false });
  readonly toast$ = this._toast$.asObservable();

  showError(errorDescription: any, options?: Toast) {
    console.log(errorDescription)
    this._toast$.next({
      ...options,
      title: 'Error message!',
      description: errorDescription?.detail ?? errorDescription?.message ?? 'An unexpected error occurred.',
      type: 'error',
      duration: options?.duration ?? DEFAULT_DURATION,
      show: true
    });
  }

  showSuccess(options: Toast) {
    this._toast$.next({
      ...options,
      title: 'Success message!',
      duration: options.duration ?? DEFAULT_DURATION,
      show: true
    });
  }

  showWarning(warningDescription: string, options?: Toast) {
    this._toast$.next({
      ...options,
      title: 'Warning message!',
      description: warningDescription,
      type: 'warning',
      duration: options?.duration ?? DEFAULT_DURATION,
      show: true
    });
  }

  remove() {
    console.log('Toast removed')
    this._toast$.next({ description: '', show: false });
  }
}
